import { Button, Card, message, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { controller as treatmentsController } from "../../TreatmentPlans/controller";
import { controller } from "../../../controller";

// import { useGetPatientInsuranceEligibility } from "../useGetPatientInsuranceEligibility";
// import PatientPolicyInfoFormModal from "../PatientPolicyInfoFormModal";
import BreakdownProceduresTable from "./BreakdownProceduresTable";
// import Eligibility2FAFormModal from "../Eligibility2FAFormModal";
import ConfirmRecalculateModal from "./ConfirmRecalculateModal";
import BreakdownRequestModal from "./BreakdownRequestModal";
import BreakDownUploadedFile from "./BreakDownUploadedFile";
import BreakdownFinanceLabel from "./BreakdownFinanceLabel";
import ApproveButton from "./ApproveButton";
// import AddPatientModal from "../AddPatientModal";
// import ApproveButton from "./ApproveButton";

// INFO: `breakdown` is what that was returned in the `doctor-note-lc` endpoint
// INFO: `breakdownData` is the breakdown data that we refetch after editing or adding a new procedure
// INFO: the `breakdownData` is just the same as `breakdown` but it has data after an action like editing/adding a procedure
export default function BreakdownModal({
  setShowInsuranceBreakdownModal,
  showInsuranceBreakdownModal,
  //   setLastUploadedBreakdown,
  //   isGettingDoctorNote,
  breakdown,
  patient,
}) {
  //   const [showPatientInsuranceFormModal, setShowPatientInsuranceFormModal] = useState(false);
  const [showConfirmRecalculateModal, setShowConfirmRecalculateModal] = useState(false);
  //   const [showEligibility2FAFormModal, setShowEligibility2FAFormModal] = useState(false);
  const [hasBasciMajorOrthoUpdated, setHasBasciMajorOrthoUpdated] = useState(false); // To check if basic or major or ortho valuea updated or not
  //   const [editPatientInsuranceData, setEditPatientInsuranceData] = useState(false);
  const [isLoadingInsuranceData, setIsLoadingBreakdownsData] = useState(false);
  const [showNewBreakdownModal, setShowNewBreakdownModal] = useState(false);
  const [isGettingProcedures, setIsGettingProcedures] = useState(false); // Loading for the time that all procedures are fetching
  const [confirmRecalculate, setConfirmRecalculate] = useState(false);
  const [isGettingPatients, setIsGettingPatients] = useState(false); // Loading for the time that all patients are fetching
  //   const [showAddPatient, setShowAddPatient] = useState(false); // Loading for the time that insurance patient is changed
  //   const [cancelProcess, setCancelProcess] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [allPatients, setAllPatients] = useState([]); // All office patients
  const [allProcedures, setAllProcedures] = useState([]);
  const [breakdownData, setBreakdownData] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(undefined);
  const [breakdownStatus, setBreakdownStatus] = useState(undefined);
  const [newBreakdownID, setNewBreakdownID] = useState(undefined);
  const [basicMajorOrthoData, setBasicMajorOrthoData] = useState({
    preventative: { overall_max: undefined, coverage: undefined, benefits_remaining: undefined },
    basic: { overall_max: undefined, coverage: undefined, benefits_remaining: undefined },
    major: { overall_max: undefined, coverage: undefined, benefits_remaining: undefined },
    orthodontics: { overall_max: undefined, coverage: undefined, benefits_remaining: undefined },
  });
  // Category groups that share one dollar maximum, e.g. [["Basic","Preventative"]].
  const [sharedMaxGroups, setSharedMaxGroups] = useState([]);
  // Other categories that share the given category's max pool (for the card badge).
  const sharesMaxWith = (category) => {
    const c = String(category || "").toLowerCase();
    for (const g of sharedMaxGroups || []) {
      if (Array.isArray(g) && g.some((x) => String(x).toLowerCase() === c)) {
        return g.filter((x) => String(x).toLowerCase() !== c);
      }
    }
    return [];
  };

  //   const {
  //     checkPatientInsuranceEligibility,
  //     isLoading: isAgentGettingBreakdownData,
  //     eligibilityData: breakdownAgentData,
  //     eligibilityAgentToken,
  //   } = useGetPatientInsuranceEligibility(
  //     patient && patient.id,
  //     setShowPatientInsuranceFormModal,
  //     setShowEligibility2FAFormModal,
  //     "breakdown",
  //     cancelProcess
  //   );

  // SECTION: fetch data
  // Getting all office patients
  useEffect(function () {
    async function getAllPatients() {
      try {
        setIsGettingPatients(true);
        const res = await controller.getPatient2();
        setAllPatients(res);
      } catch (err) {
        message.error("Something went wrong while fetching patients");
        console.error(err);
      } finally {
        setIsGettingPatients(false);
      }
    }
    getAllPatients();
  }, []);

  // Getting all procedures
  useEffect(function () {
    async function getAllProcedures() {
      try {
        setIsGettingProcedures(true);
        const res = await treatmentsController.getProcedure(0, "");
        setAllProcedures(res.json);
      } catch (err) {
        message.error("Something went wrong while fetching procedures");
        console.error(err);
      } finally {
        setIsGettingProcedures(false);
      }
    }
    getAllProcedures();
  }, []);

  // SECTION: Reactions
  // Setting breakdown status, patient name and status label color
  useEffect(function () {
    if (!breakdownData || breakdownData.status === "processing") return;
    setBreakdownStatus(breakdownData.status);
  }, []);

  // Find the selected patient for dropdown
  useEffect(
    function () {
      if (breakdownData && breakdownData.patient && allPatients) {
        const patient = allPatients.find((patient) => patient.id === breakdownData.patient);
        setSelectedPatient(patient);
      }
    },
    [breakdownData, allPatients]
  );

  useEffect(
    function () {
      async function getBreakdownDetails() {
        if (!breakdown) return;

        try {
          setIsLoadingBreakdownsData(true);

          console.log(breakdown);
          const breakdownPatientCoverageResponse = await controller.getBreakdownPatientCoverage(breakdown.patient);
          console.log(breakdownPatientCoverageResponse);

          if (breakdownPatientCoverageResponse.status < 250) {
            const {
              preventative_benefits_remaining,
              preventative_percentage,
              preventative_overall_max,
              basic_benefits_remaining,
              basic_percentage,
              basic_overall_max,
              major_benefits_remaining,
              major_percentage,
              major_overall_max,
              orthodontics_benefits_remaining,
              orthodontics_percentage,
              orthodontics_overall_max,
            } = breakdownPatientCoverageResponse.json;

            setBasicMajorOrthoData({
              preventative: {
                overall_max: preventative_overall_max,
                coverage: preventative_percentage,
                benefits_remaining: preventative_benefits_remaining,
              },
              basic: { overall_max: basic_overall_max, coverage: basic_percentage, benefits_remaining: basic_benefits_remaining },
              major: { overall_max: major_overall_max, coverage: major_percentage, benefits_remaining: major_benefits_remaining },
              orthodontics: {
                overall_max: orthodontics_overall_max,
                coverage: orthodontics_percentage,
                benefits_remaining: orthodontics_benefits_remaining,
              },
            });
            setSharedMaxGroups(breakdownPatientCoverageResponse.json.category_shared_max_groups || []);
            setTableData(breakdown.patient_procedure_coverages);
          }
        } catch (err) {
          message.error("Something went wrong while getting breakdown data");
          console.error(err);
        } finally {
          setIsLoadingBreakdownsData(false);
        }
      }
      getBreakdownDetails();
    },
    [breakdown]
  );

  //   useEffect(
  //     function () {
  //       if (!breakdown) return;
  //       getBreakdownsDetailsData();
  //     },
  //     [breakdown]
  //   );

  // Fetch the insurance breakdownData
  //   useEffect(
  //     function () {
  //       if (newBreakdownID) {
  //         getBreakdownsDetailsData();
  //       }
  //     },
  //     [newBreakdownID]
  //   );

  // Update insurance breakdown data in UI
  //   useEffect(
  //     function () {
  //       if (breakdownAgentData !== undefined) {
  //         setBreakdownData(breakdownAgentData);
  //         setTableData(breakdownAgentData.patient_procedure_coverages);
  //         setNewBreakdownID(breakdownAgentData.id);
  //       }
  //     },
  //     [breakdownAgentData]
  //   );

  // Do the breakdown recalculation if user confirmed recalculation
  useEffect(
    function () {
      if (confirmRecalculate) {
        performRecalculate();
      }
    },
    [confirmRecalculate]
  );

  // SECTION: Functions
  //   async function getBreakdownsDetailsData() {
  //     try {
  //       setIsLoadingBreakdownsData(true);
  //       await getInsuranceBreakdownDetails();
  //     } catch (err) {
  //       message.error("Something went wrong while getting insurance breakdown details.");
  //       console.error(err);
  //     } finally {
  //       setIsLoadingBreakdownsData(false);
  //     }
  //   }

  // Getting breakdowns details
  const getInsuranceBreakdownDetails = async () => {
    if ((breakdown && breakdown.id) || newBreakdownID) {
      const response = await treatmentsController.getBreakdownDetailByPatient(patient.id);
      const breakdownPatientCoverageResponse = await controller.getBreakdownPatientCoverage(response.json.patient);

      if (breakdownPatientCoverageResponse.status < 250) {
        const {
          preventative_benefits_remaining,
          preventative_percentage,
          preventative_overall_max,
          basic_benefits_remaining,
          basic_percentage,
          basic_overall_max,
          major_benefits_remaining,
          major_percentage,
          major_overall_max,
          orthodontics_benefits_remaining,
          orthodontics_percentage,
          orthodontics_overall_max,
        } = breakdownPatientCoverageResponse.json;

        setBasicMajorOrthoData({
          preventative: {
            overall_max: preventative_overall_max,
            coverage: preventative_percentage,
            benefits_remaining: preventative_benefits_remaining,
          },
          basic: { overall_max: basic_overall_max, coverage: basic_percentage, benefits_remaining: basic_benefits_remaining },
          major: { overall_max: major_overall_max, coverage: major_percentage, benefits_remaining: major_benefits_remaining },
          orthodontics: {
            overall_max: orthodontics_overall_max,
            coverage: orthodontics_percentage,
            benefits_remaining: orthodontics_benefits_remaining,
          },
        });
        setTableData(response.json.patient_procedure_coverages);
      }

      setBreakdownData(response.json);
    }
  };

  // A check before recalculation
  const handleRecalculate = async () => {
    // Shwo the confirm modal before calling the recalculate function
    if (hasBasciMajorOrthoUpdated && !confirmRecalculate) {
      setShowConfirmRecalculateModal(true);
      return;
    }

    performRecalculate();
  };

  // Recalculate breakdown
  async function performRecalculate() {
    try {
      setIsApproving(true);
      // TODO: Get breakdowns financing values from this response
      // const response = await treatmentsController.recalculateBreakdown(newBreakdownID || (breakdown && breakdown.id));
      const response = await treatmentsController.recalculateBreakdown(patient.id);

      if (response.status < 250) {
        message.success("Recalculated successfully!");

        // Reset states to normal for showing modal after changing basic or major or ortho
        if (hasBasciMajorOrthoUpdated) {
          setHasBasciMajorOrthoUpdated(false);
          setConfirmRecalculate(false);
        }
      }
    } catch (err) {
      message.error("Something went wrong while recalculating breakdown");
      console.error(err);
    } finally {
      setIsApproving(false);
    }
    await getInsuranceBreakdownDetails();
  }

  return (
    <>
      <Modal
        open={showInsuranceBreakdownModal}
        style={{ padding: 10 }}
        width="75%"
        height="80%"
        footer={null}
        // closeIcon={false}
        onCancel={() => setShowInsuranceBreakdownModal(false)}
      >
        {isLoadingInsuranceData || isGettingPatients || isGettingProcedures ? (
          <div style={{ width: "100%", height: 200, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, gap: 10 }}>
            <Spin />
            loading...
          </div>
        ) : (
          <>
            <div style={{ padding: "20px 10px" }}>
              <div className="breakdown-modal-header">
                <p style={{ margin: 0, fontSize: 20 }}>{patient && patient.first_name}'s Insurnace breakdowns</p>

                {/* <div className="breakdown-modal-header-buttons-container">
                  <Button type="primary" onClick={() => setShowNewBreakdownModal((show) => !show)} style={{ fontSize: 12 }}>
                    Upload New Breakdown
                  </Button>

                  <Button
                    type="primary"
                    onClick={() => {
                      setCancelProcess(false);
                      checkPatientInsuranceEligibility();
                    }}
                    style={{ fontSize: 12 }}
                    loading={isAgentGettingBreakdownData}
                  >
                    Fetch By Agent
                  </Button>

                  <Button
                    onClick={() => setShowInsuranceBreakdownModal(false)}
                    style={{ display: "flex", alignItems: "center", gap: 5, border: "2px solid #6b43b5", color: "#6b43b5", fontSize: 12 }}
                  >
                    Close
                  </Button>
                </div> */}
              </div>

              <Card>
                <div>
                  {breakdownStatus !== "processing" && (
                    <Card style={{ width: "100%", marginBottom: 30, position: "relative" }}>
                      <div className="breakdown-labels-container">
                        <BreakdownFinanceLabel
                          status="Preventative"
                          breakdownID={(breakdown && breakdown.id) || newBreakdownID}
                          basicMajorOrthoData={basicMajorOrthoData}
                          setBasicMajorOrthoData={setBasicMajorOrthoData}
                          setHasBasciMajorOrthoUpdated={setHasBasciMajorOrthoUpdated}
                          patientID={patient.id}
                          sharesMaxWith={sharesMaxWith("Preventative")}
                        />
                        <BreakdownFinanceLabel
                          status="Basic"
                          breakdownID={(breakdown && breakdown.id) || newBreakdownID}
                          basicMajorOrthoData={basicMajorOrthoData}
                          setBasicMajorOrthoData={setBasicMajorOrthoData}
                          setHasBasciMajorOrthoUpdated={setHasBasciMajorOrthoUpdated}
                          patientID={patient.id}
                          sharesMaxWith={sharesMaxWith("Basic")}
                        />
                        <BreakdownFinanceLabel
                          status="Major"
                          breakdownID={(breakdown && breakdown.id) || newBreakdownID}
                          basicMajorOrthoData={basicMajorOrthoData}
                          setBasicMajorOrthoData={setBasicMajorOrthoData}
                          setHasBasciMajorOrthoUpdated={setHasBasciMajorOrthoUpdated}
                          patientID={patient.id}
                          sharesMaxWith={sharesMaxWith("Major")}
                        />
                        <BreakdownFinanceLabel
                          status="Orthodontics"
                          breakdownID={(breakdown && breakdown.id) || newBreakdownID}
                          basicMajorOrthoData={basicMajorOrthoData}
                          setBasicMajorOrthoData={setBasicMajorOrthoData}
                          setHasBasciMajorOrthoUpdated={setHasBasciMajorOrthoUpdated}
                          patientID={patient.id}
                          sharesMaxWith={sharesMaxWith("Orthodontics")}
                        />
                      </div>
                    </Card>
                  )}
                </div>

                <Card>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                    <p style={{ fontSize: 18, marginBottom: 0 }}>Insurance Breakdown Policy</p>
                  </div>

                  <BreakdownProceduresTable
                    patient={patient}
                    breakdown={breakdown}
                    breakdowns={tableData}
                    setTableData={setTableData}
                    allProcedures={allProcedures}
                    newBreakdownID={newBreakdownID}
                    selectedPatient={selectedPatient}
                    setNewBreakdownID={setNewBreakdownID}
                    // getBreakdownsDetailsData={getBreakdownsDetailsData}
                  />
                </Card>

                {breakdownData && breakdownData.files && breakdownData.files.length > 0 && (
                  <div style={{ marginTop: 30 }}>
                    <p style={{ fontSize: 18 }}>Uploaded Files</p>

                    <div style={{ display: "flex", alignItems: "center", flexDirection: "row", flexWrap: "wrap", gap: 20 }}>
                      {breakdownData.files.map((file, index) => (
                        <BreakDownUploadedFile key={index} file={file} />
                      ))}
                    </div>
                  </div>
                )}
              </Card>

              {/* Recalculate intentionally hidden in breakdown lightbox */}
              <div style={{ marginTop: 30, display: "flex" }}>
                {false && (
                  <ApproveButton
                    hasBreakdownID={(breakdown && breakdown.id) || newBreakdownID}
                    numberofBreakdowns={tableData.length}
                    handleRecalculate={handleRecalculate}
                    isApproving={isApproving}
                  />
                )}
              </div>

              {/* Modal for adding patient */}
              {/* <AddPatientModal showAddPatient={showAddPatient} setShowAddPatient={setShowAddPatient} /> */}
            </div>

            {/* Request New Breakdown Modal */}
            <BreakdownRequestModal
              setShowNewBreakdownModal={setShowNewBreakdownModal}
              setNewBreakdownID={setNewBreakdownID}
              showNewBreakdownModal={showNewBreakdownModal}
              patient={patient}
            />
          </>
        )}
      </Modal>

      <ConfirmRecalculateModal
        setShowConfirmRecalculateModal={setShowConfirmRecalculateModal}
        showConfirmRecalculateModal={showConfirmRecalculateModal}
        setConfirmRecalculate={setConfirmRecalculate}
      />

      {/* Eligibility Form Modal */}
      {/* <PatientPolicyInfoFormModal
        setShowPatientInsuranceFormModal={setShowPatientInsuranceFormModal}
        checkPatientInsuranceEligibility={checkPatientInsuranceEligibility}
        showPatientInsuranceFormModal={showPatientInsuranceFormModal}
        setEditPatientInsuranceData={setEditPatientInsuranceData}
        editPatientInsuranceData={editPatientInsuranceData}
        setCancelProcess={setCancelProcess}
        patientID={patient && patient.id}
      /> */}

      {/* 2FA Form Modal */}
      {/* <Eligibility2FAFormModal
        setShowEligibility2FAFormModal={setShowEligibility2FAFormModal}
        showEligibility2FAFormModal={showEligibility2FAFormModal}
        eligibilityAgentToken={eligibilityAgentToken}
        type="breakdown"
      /> */}
    </>
  );
}
